import background from "./images/map_picture.jpg";

let SASSY = {
  questions: [{
      "type": "radiogroup",
      "name": "Qnum1",
      "title": "How important is the issue of global warming to you personally?",
      "choices": [
        {text: "Extremely important", value: 1},
        {text: "Very important", value: 2},
        {text: "Somewhat important", value: 3},
        {text: "Not too important", value: 4},
        {text: "Not at all important", value: 5},
      ],
      isRequired: true,
      defaultValue: null
    }, {
      "type": "radiogroup",
      "name": "Qnum2",
      "title": "How worried are you about global warming?",
      "choices": [
        {text: "Very worried", value: 1},
        {text: "Somewhat worried", value: 2},
        {text: "Not very worried", value: 3},
        {text: "Not at all worried", value: 4}
      ],
      isRequired: true,
      defaultValue: null
    },
    {
      "type": "radiogroup",
      "name": "Qnum3",
      "title": "How much do you think global warming will harm you personally?",
      "choices": [
        {text: "A great deal", value: 1},
        {text: "A moderate amount", value: 2},
        {text: "Only a little", value: 3},
        {text: "Not at all", value: 4},
        {text: "Don't know", value: 5}
      ],
      isRequired: true,
      defaultValue: null
    }, {
      "type": "radiogroup",
      "name": "Qnum4",
      "title": "How much do you think global warming will harm future generations of people?",
      "choices": [
        {text: "A great deal", value: 1},
        {text: "A moderate amount", value: 2},
        {text: "Only a little", value: 3},
        {text: "Not at all", value: 4},
        {text: "Don't know", value: 5}
      ],
      isRequired: true,
      defaultValue: null
    }
  ],
  frontPage: {
    elements: [
      {
        "type": "html",
        "name": "info",
        "html": `
        <h5 class="sassy-intro"><a href="http://climatecommunication.yale.edu/about/projects/global-warmings-six-americas/" target="_blank">Global Warming's Six Americas</a> is an audience segmentation tool designed to help people better understand their own climate views as well as others. The original questionnaire was based on 36 items, but has now been reduced to just four questions in the Six Americas Super Short SurveY (SASSY).</h5>
        <img class="sassy-graphic" src="${background}">
        `
      }
    ]
  },
  resultPage: `
    <div class="results-page">
    <h5 class="sassy-intro">Your Six Americas Segment is {segment}</h5>
    <img id="result-image" class="sassy-graphic" src="{resultImage}">
    <button class="btn btn-default action-button shiny-bound-input" id="HomeSix AmericasButton20180730070200" style="width: 200px; font-size:22px" type="button"><a href="./index.html">Home</a></button><br/>
    <div class="sassy-footnote">
        The question scoring is based on a statistical model by <a href="https://doi.org/10.1080/17524032.2018.1508047" target="_blank">Chryst et al. (2018)</a>. The Six Americas are described in detail in <a href="http://journals.plos.org/plosone/article?id=10.1371/journal.pone.0017571" target="_blank">Maibach et al. (2011)</a>. <br/><br/>If you have any questions regarding the survey please send an email to <a href="mailto:climatechange@yale.edu">climatechange@yale.edu</a>.
    </div>
    <div class="sassy-footnote">
    <a href="http://climatecommunication.yale.edu/about/projects/global-warmings-six-americas/" style="color:#2F4F4F" target="_blank">Learn more about Global Warming's Six Americas</a>.
    </div></div>`
};

export default SASSY;